import React from 'react';

const ProductLowStock = () => <p className="rs_product_low_stock"> Limited Stock!</p>;

export default ProductLowStock;
